module.exports = __webpack_public_path__ + "img/image-mt-9.675017c5.png";